import React, { useState, useEffect } from "react";
import "../Header/styles.css"
import api from "../Services/api";
import icoTimeline from "../../assets/img/historia/ico-timeline.svg";
import "../../assets/css/dist/historia.dist.css";

const Timeline = () => {

    const [timeline, setTimeline] = useState<any[]>([]);
  
    useEffect(() => {
        api
            .get("/ObterLinhaDoTempo")
            .then((response) => {
                setTimeline(response.data.results);
            })
            .catch((err) => {
                throw new Error(err);
                 
            });
    }, []);     
  
    return (
        <section className="timeline py-6 py-lg-8">
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-md-4 mb-5'>
                        <h2 className="h3"> Linha do tempo </h2>
                    </div>
                    <div className="col-md-6">
                        <div className="timeline__list">
                            <ul className="list-unstyled">
                                {timeline?.map((item, index) => (
                                    <li key={index}>
                                        <div className="box-ico rounded bg-primary">
                                            <img src={icoTimeline} alt="" />
                                        </div>
                                        <div className="box-text">
                                            <h4> {item?.Title} </h4>
                                            <p>
                                                {item?.Descricao}
                                            </p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Timeline;